import { Component, Input } from '@angular/core';
import { GeralService } from 'src/app/core/services/geral-service/geral-service';
import { SnackbarService } from 'src/app/shared/components/snackbar/service/snackbar.service';

@Component({
  selector: 'app-product-contacts',
  templateUrl: './product-contacts.component.html',
  styleUrls: ['./product-contacts.component.scss']
})
export class ProductContactsComponent {
  @Input() data: any;
  @Input() condition: string;

  constructor(
    public geralService: GeralService,
    public snackService: SnackbarService
  ) { }

}
